import { motion } from 'framer-motion';
import { Target, Sparkles } from 'lucide-react';
import { LuckyWheel } from '../components';

export function GamesPage() {
  return (
    <div className="space-y-5">
      {/* Lucky Wheel */}
      <LuckyWheel />

      {/* Game tips */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="card p-4"
      >
        <h4 className="font-bold mb-3 flex items-center gap-2">
          <Target className="w-5 h-5 text-yellow-400" />
          How to Win More
        </h4>
        <ul className="space-y-2 text-xs text-white/60">
          <li className="flex items-start gap-2">
            <Sparkles className="w-3 h-3 text-primary mt-0.5 flex-shrink-0" />
            <span>Higher levels unlock bigger wheel prizes</span>
          </li>
          <li className="flex items-start gap-2">
            <Sparkles className="w-3 h-3 text-primary mt-0.5 flex-shrink-0" />
            <span>Spin the wheel daily for bonus rewards</span>
          </li>
          <li className="flex items-start gap-2">
            <Sparkles className="w-3 h-3 text-primary mt-0.5 flex-shrink-0" />
            <span>Games reset daily at midnight UTC</span>
          </li>
        </ul>
      </motion.div>
    </div>
  );
}
